


































































import { Prop, Component, Vue } from "vue-property-decorator";
import { FolderEntry, Breadcrumb } from "@/models/file";
import IReportOutput from "@/api/models/IReportOutput";
import IReportSceneOutput from "@/api/models/IReportSceneOutput";
import createReportSceneOutput from "@/api/models/factories/createReportSceneOutput";

import VButtonMinus from "@/components/VButtonMinus.vue";
import VButtonPlusBlock from "@/components/VButtonPlusBlock.vue";
import VReportSceneControl from "@/components/VReportSceneControl.vue";
import VReportSelectModal from "@/components/VReportSelectModal.vue";
import formatDate from "@/helpers/formatDate.ts";

import SwitchButton from "@/components/SwitchButton.vue";

@Component({
  components: {
    VButtonMinus,
    VButtonPlusBlock,
    VReportSceneControl,
    VReportSelectModal,
    SwitchButton
  }
})
export default class ReportEdit extends Vue {
  @Prop({ required: true }) report!: IReportOutput;
  @Prop({ required: true }) scenes!: IReportSceneOutput[];
  @Prop({ default: () => [] }) entries!: FolderEntry[];
  @Prop({ default: () => [] }) breadcrumbs!: Breadcrumb[];

  scene: IReportSceneOutput | null = null;

  status = "";
  check = "";

  ok() {
    const items = this.scenes;
    items.forEach(item => {
      if (!item.photoURL && item.photoURL === "") {
        alert("写真を選択していない欄があります");
        this.check = "error";
      }
    });
    if (this.check != "error") {
      this.status = "progressing";
      this.$emit("ok");
    } else {
      this.check = "";
    }
  }

  cd(id: string) {
    this.$emit("cd", id);
  }

  uploadPhoto(files: File[]) {
    this.$emit("uploadPhoto", files);
  }

  showReportModal() {
    this.cd("0");
    (this.$refs.reportModal as any).show();
  }

  areScenesEmpty() {
    return this.scenes.every(
      s => !s.photoId && !s.state && !s.date && !s.note && !s.photoURL
    );
  }

  importPhotoList(entries: FolderEntry[]) {
    if (!entries.length) return;
    if (this.areScenesEmpty()) {
      this.scenes.splice(0, this.scenes.length);
    }
    entries.forEach(e => {
      const s = createReportSceneOutput();
      s.photoId = String(e.entryId);
      s.photoURL = e.image;
      this.scenes.push(s);
    });
  }

  showSceneModal(scene: IReportSceneOutput) {
    this.scene = scene;
    this.cd("0");
    (this.$refs.sceneModal as any).show();
  }

  changePhoto(entries: FolderEntry[]) {
    if (!this.scene) return;
    if (!entries.length) return;
    const photo = entries[0];
    this.scene.photoId = String(photo.entryId);
    this.scene.photoURL = String(photo.image);
    this.scene.date = formatDate(photo.updated);
    this.scene = null;
  }

  addScene() {
    this.scenes.push(createReportSceneOutput());
  }

  removeScene(i: number) {
    this.scenes.splice(i, 1);
  }

  swapScenes(i: number, j: number) {
    const a = this.scenes[i];
    const b = this.scenes[j];
    if (a && b) {
      this.$set(this.scenes, i, b);
      this.$set(this.scenes, j, a);
    }
    console.info("swap", this.scenes);
  }
}
